import React, { useEffect, useState } from 'react';
import './aboutUsStyle.css';
import ReadMoreButton from '../../../../components/buttons/readMoreButton/readMoreButton';
import H2Title from './../../../../components/text/h2Title/h2Title'
import NormalTex from './../../../../components/text/normalText'

export default function AboutUs({title, text, imgSrc}) {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    const handleResize = () => {
        setWindowWidth(window.innerWidth)
    };

    useEffect( () => {
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        }
    }, [])

    if (windowWidth < 769)
        return (
            <section className='about-us__container'>
                <div className='about-us__text-container'>
                    <H2Title title={title} />

                    <div className='about-us__img-container'>
                        <img className='about-us__img' src={imgSrc} alt="" />
                    </div>

                    <NormalTex text={text}/>

                    <ReadMoreButton url={"/aboutUs"}/>
                </div>
                
            </section>
        );

    return (
        <section className='about-us__container'>
            <div className='about-us__text-container'>
                <H2Title title={title} />
                <NormalTex text={text}/>
                <ReadMoreButton url={"/about-us"}/>
            </div>
            <div className='about-us__img-container'>
                <img className='about-us__img' src={imgSrc} alt="" />
            </div>
        </section>
    );
}
